import * as React from 'react';
import { AvailabilityGranularitySelect, type Granularity } from './availability-granularity-select';
import { Legend, type LegendItem } from '../../../availability';

export interface AvailabilitySubToolbarProps {
  granularity: Granularity;
  onGranularityChange: (value: Granularity) => void;
  legendItems: LegendItem[];
  /** Shown next to the controls while a chunk is loading (e.g. "Wczytuję kolejne okresy..."). */
  loadingLabel?: string;
  testId?: string;
  /** testId for the inner `AvailabilityGranularitySelect` trigger. Defaults to `'granularity-select'`. */
  granularityTestId?: string;
}

/**
 * Dedicated slim strip holding the availability-column controls (granularity selector +
 * legend). Mounted as its own sibling row directly above the catalog `DataTable` — not
 * inside the results/filter toolbar above — so toggling the availability columns on/off
 * never reflows that toolbar; it only inserts/removes this one thin row.
 *
 * The "load more periods" affordance is NOT rendered here — it lives as a trailing
 * `DataTable` column (see `buildLoadMoreColumn`) so its purpose (extend the timeline
 * rightward) reads naturally at the true right edge of the availability columns.
 */
export function AvailabilitySubToolbar({
  granularity,
  onGranularityChange,
  legendItems,
  loadingLabel,
  testId = 'availability-subtoolbar',
  granularityTestId = 'granularity-select',
}: AvailabilitySubToolbarProps) {
  return (
    <div
      className="shrink-0 flex items-center gap-3 px-6 py-1 border-y border-border/60 bg-muted/30"
      data-testid={testId}
    >
      <AvailabilityGranularitySelect
        value={granularity}
        onValueChange={onGranularityChange}
        testId={granularityTestId}
      />
      <Legend items={legendItems} />
      {loadingLabel ? <span className="text-2xs text-muted-foreground">{loadingLabel}</span> : null}
    </div>
  );
}
